import { DASHBOARDS_LEARNING_PAGE_KEY } from './constants';
import type { TTranslations } from './types';

// TODO: l10n review — translations are functional equivalents of the Spanish source
export const en: TTranslations = {
  [DASHBOARDS_LEARNING_PAGE_KEY]: {
    PAGE_TITLE: 'Learning',
    PAGE_SUBTITLE:
      'Track usage of the learning platform. Own courses vs Crehana catalog, quarterly trends, certifications and satisfaction.',
    NEW_TAG: 'New',
    FRESHNESS_PREFIX: 'Last updated:',
    FRESHNESS_DATE: 'May 14, 09:00 AM',
    PRODUCT_SELECTOR_LABEL: 'Product',
    PRODUCT_SELECTOR_HELPER: 'Select the product you want to analyze',
    PRODUCT_GENERAL: 'General',
    PRODUCT_LEARNING: 'Learning',
    BREADCRUMB_ROOT: 'Analytics Hub',
    BREADCRUMB_DASHBOARDS: 'Dashboards',
    BREADCRUMB_LEARNING: 'Learning',
    TAB_GENERAL: 'General',
    TAB_PATHS: 'By paths',
    TAB_COURSES: 'By courses',
    TAB_USERS: 'By users',
    TAB_PLACEHOLDER_PATHS: 'Paths content coming soon',
    TAB_PLACEHOLDER_COURSES: 'Courses content coming soon',
    TAB_PLACEHOLDER_USERS: 'Users content coming soon',
    EMPTY_TITLE: 'No modules available',
    EMPTY_DESCRIPTION: 'When learning data is available, you will see it here.',
    ERROR_TITLE: 'Error loading dashboard',
    ERROR_RETRY: 'Retry',
    CERT_SECTION_TITLE: 'Certificates',
    CERT_SECTION_DESC:
      'A certificate is issued when a user completes a course that has certification enabled. A single user can earn multiple certificates (one per completed course).',
    HISTORIC_CHIP: 'Historical · not period-dependent',
    CERT_KPI_TOTAL_LABEL: 'Certificates issued (total)',
    CERT_KPI_USERS_LABEL: 'Users with at least 1 certificate',
    CERT_KPI_AVG_LABEL: 'Average certificates per user',
    CERT_CHART_TITLE: 'Certificates issued per month',
    CERT_CHART_HELPER: 'Last 16 months · Certificates issued per month',
    CERT_CHART_BARS_LEGEND: 'Certificates',
    CSAT_SECTION_TITLE: 'Survey Satisfaction — Key tracks',
    CSAT_TABLE_TITLE: 'Survey satisfaction by key track',
    CSAT_COL_ROUTE: 'Track',
    CSAT_COL_SCORE: 'CSAT (1–5)',
    CSAT_COL_SCORE_TOOLTIP:
      'Average CSAT of the courses in this track. Different from the individual course rating shown in the key metrics block.',
    CSAT_COL_RESPONSES: 'Responses',
    CSAT_COL_UNIQUE_USERS: 'Unique users',
    CSAT_SCORE_SUFFIX: '/5',
    CSAT_EMPTY_TITLE: 'No key tracks',
    CSAT_EMPTY_DESC: 'No tracks launched in the last 90 days.',
    CSAT_ERROR_TITLE: 'Failed to load CSAT data',
    CSAT_ERROR_RETRY: 'Retry',
  },
};
